import React from "react";
import ApexLine from "./ApexLine";
import ApexLineTemp from "./ApexLineTemp";
import { useState, useEffect, useContext } from "react";
import { MyContext } from "../../context";

function ClientGraph(props) {
  const { RightLinkSelection } = useContext(MyContext);

  const [Temparature, setTemparature] = useState("voltage");

  return (
    <>
      <div className="card" style={{ width: "18rem;" }}>
        <div className="card-body">
          <div style={{ display: "flex" }}>
            {Temparature === "voltage" ? (
              <p className="card-title">
                <strong>{RightLinkSelection} Voltage </strong>{" "}
                <span className="Font-primary">
                  <strong>{props.name}</strong>
                </span>
              </p>
            ) : (
              <p className="card-title">
                <strong>{RightLinkSelection} Voltage </strong>{" "}
                <span className="Font-Blue">
                  <strong>{props.name}</strong>
                </span>
              </p>
            )}

            <span className="leftAling" style={{ display: "flex" }}>
              <div
                className="buttonCard1"
                onClick={() => setTemparature("temparature")}
              >
                Temparature
              </div>

              <div
                className="buttonCard"
                onClick={() => setTemparature("voltage")}
              >
                Voltage
              </div>

              
              <div class="dropdown">
                <span className="info" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{marginBottom:"20px"}}>
                  <span class="material-symbols-rounded">more_horiz</span>
                </span>
                <div class="dropdown-menu" aria-labelledby="" style={{marginTop:"15px", marginLeft:"-5px"}}>
                <a class="dropdown-item" href="#">Last 24 Hours</a>
    <a class="dropdown-item" href="#">Last Week</a>
    <a class="dropdown-item" href="#">Last 30 Days</a>
  </div></div>

               
              

            </span>
          </div>

          <div className="d-flex">
            <div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
                battery_5_bar
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px" }}>
                <strong>
                  Min {Temparature === "voltage" ? "voltage" : "temparature"}:{" "}
                </strong>
              </span>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 
              {Temparature === "voltage" ? (
                <p className="Font-primary currentCharging">26.07 V</p>
              ) : (
                <p className="Font-Blue currentCharging">26.07 ℃</p>
              )}
            </div>

            <div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
                battery_5_bar
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px" }}>
                <strong>
                  Max {Temparature === "voltage" ? "voltage" : "temparature"}:{" "}
                </strong>
              </span>
              {Temparature === "voltage" ? (
                <p className="Font-primary currentCharging">56.07 V</p>
              ) : (
                <p className="Font-Blue currentCharging">46.07 ℃</p>
              )}
            </div>
          </div>
          <hr />

          {Temparature === "voltage" ? <ApexLine /> : <ApexLineTemp />}
        </div>
      </div>
    </>
  );
}

export default ClientGraph;
